import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../../_ThemeTwo_';

export const HeaderSubNav = Styled.div`
  display: flex;
  flex-direction: row;
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colorWhite};
  border-bottom: 1px solid ${({ theme }) => theme.colorSlate10};
  z-index: 222;

  ${({ theme: { header: { headerSubNav }, themeTwo }}) => headerSubNav && css`
    z-index: ${themeTwo.global.zIndex.high};
    ${headerSubNav.border && cssDeclaration(themeTwo, 'border', headerSubNav.border)}
  `}
`;

HeaderSubNav.displayName = 'HeaderSubNav';
